import Http from '@/api/http';

export default class PieceworkSalary extends Http {
  constructor() {
    super();
  }
  /**
   * 薪酬记件表查询
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getPieceworkSalaryList() {
    return super.post('pieceworkSalary/getPieceworkSalaryList', ...arguments);
  }
  /**
   * 薪酬记件表总数
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getPieceworkSalaryTotal() {
    return super.post('pieceworkSalary/getPieceworkSalaryTotal', ...arguments);
  }
  /**
   * 薪酬记件表 单行更新
   * @param {*} params
   * @returns
   */
  pieceworkSalary_changePieceworkSalaryInfo() {
    return super.post('pieceworkSalary/changePieceworkSalaryInfo', ...arguments);
  }
  /**
   * 薪酬记件表 导出
   * @param {*} params
   * @returns
   */
  pieceworkSalary_export() {
    return super.post('pieceworkSalary/export', ...arguments);
  }
  /**
   * 获取审核费用明细
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getAuditCostList() {
    return super.post('pieceworkSalary/getAuditCostList', ...arguments);
  }
  /**
   * 获取全职辅助费用
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getFullTimeAssistanceCost() {
    return super.post('pieceworkSalary/getFullTimeAssistanceCost', ...arguments);
  }
  /**
   * 获取全职辅助费用总计
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getFullTimeAssistanceCostTotal() {
    return super.post('pieceworkSalary/getFullTimeAssistanceCostTotal', ...arguments);
  }
  /**
   * 全职辅助费用导出
   * @param {*} params
   * @returns
   */
  pieceworkSalary_fullTimeAssistanceCostExport() {
    return super.post('pieceworkSalary/fullTimeAssistanceCostExport', ...arguments);
  }
  /**
   * 招聘收入明细
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getRecruitmentIncomeList() {
    return super.post('pieceworkSalary/getRecruitmentIncomeList', ...arguments);
  }
  /**
   * 招聘收入明细总数
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getRecruitmentIncomeTotal() {
    return super.post('pieceworkSalary/getRecruitmentIncomeTotal', ...arguments);
  }
  /**
   * 招聘收入明细更改比例
   * @param {*} params
   * @returns
   */
  pieceworkSalary_recruitmentIncomeRatioChange() {
    return super.post('pieceworkSalary/recruitmentIncomeRatioChange', ...arguments);
  }
  /**
   * 招聘收入明细导出
   * @param {*} params
   * @returns
   */
  pieceworkSalary_recruitmentIncomeExport() {
    return super.post('pieceworkSalary/recruitmentIncomeExport', ...arguments);
  }
  /**
   * 获取审核费用总计
   * @param {*} params
   * @returns
   */
  pieceworkSalary_getAuditCostTotal() {
    return super.post('pieceworkSalary/getAuditCostTotal', ...arguments);
  }
  /**
   * 审核费用报告单价修改
   * @param {*} params
   * @returns
   */
  pieceworkSalary_auditCostReportUnitPriceChange() {
    return super.post('pieceworkSalary/auditCostReportUnitPriceChange', ...arguments);
  }
  /**
   * 审核费用报告导出
   * @param {*} params
   * @returns
   */
  pieceworkSalary_auditCostExport() {
    return super.post('pieceworkSalary/auditCostExport', ...arguments);
  }
  /**
   * 获取全职协助费用列表
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_getFullTimeProxyCostList() {
    return super.post('pieceworkSalary/getFullTimeProxyCost', ...arguments);
  }
  /**
   * 获取全职代审费用总计
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_getFullTimeProxyCostTotal() {
    return super.post('pieceworkSalary/getFullTimeProxyCostTotal', ...arguments);
  }
  /**
   * 全职代审费用导出
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_fullTimeProxyCostExport() {
    return super.post('pieceworkSalary/fullTimeProxyCostExport', ...arguments);
  }
  /**
   * 获取招聘费用明细列表
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_getRecruitmentFeeList() {
    return super.post('pieceworkSalary/getRecruitmentFeeList', ...arguments);
  }
  /**
   * 获取招聘费用明细总计
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_getRecruitmentFeeTotal() {
    return super.post('pieceworkSalary/getRecruitmentFeeTotal', ...arguments);
  }
  /**
   * 招聘费用明细导出
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {Array} params.brandIds 品牌ids
   * @param {string} params.taskName 任务名称
   * @param {Array} params.cityIds 城市id
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {Array} params.companyIds 企业ids
   * @returns
   */
  pieceworkSalary_recruitmentFeeExport() {
    return super.post('pieceworkSalary/recruitmentFeeExport', ...arguments);
  }
  /**
   * 困难任务指定-招聘费用 修改单价
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @param {string} params.userId 用户id
   * @param {number} params.type 状态 0：非全选，1：全选
   * @param {number} params.recruitmentFeeUnitPrice 单价
   * @returns
   */
  pieceworkSalary_recruitmentFeeUnitPriceChange() {
    return super.post('pieceworkSalary/recruitmentFeeUnitPriceChange', ...arguments);
  }
  /**
   * 销售提成列表
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户姓名
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_getSalesCommissionList() {
    return super.post('pieceworkSalary/getSalesCommissionList', ...arguments);
  }
  /**
   * 销售提成列表导出
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户姓名
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_exportSalesCommissionList() {
    return super.post('pieceworkSalary/exportSalesCommissionList', ...arguments);
  }
  /**
   * 销售提成列表汇总
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户姓名
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_getSalesCommissionTotal() {
    return super.post('pieceworkSalary/getSalesCommissionTotal', ...arguments);
  }
  /**
   * 跨区成本调整列表
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.crossRegionId 跨区成本调整id(传入时只查该条跨区成本调整对应的汇总数据)
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户名称
   * @param {number} params.userType 用户类型 1协助运营 2协助招聘毛利 3全职协助审核 4全职代审协助审核 5协助招聘收支 7签约提成 8推荐提成
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_getCrossRegionCostAdjustmentList() {
    return super.post('pieceworkSalary/getCrossRegionCostAdjustmentList', ...arguments);
  }
  /**
   * 跨区成本调整导出
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.crossRegionId 跨区成本调整id(传入时只查该条跨区成本调整对应的汇总数据)
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户名称
   * @param {number} params.userType 用户类型 1协助运营 2协助招聘毛利 3全职协助审核 4全职代审协助审核 5协助招聘收支 7签约提成 8推荐提成
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_exportCrossRegionCostAdjustmentList() {
    return super.post('pieceworkSalary/exportCrossRegionCostAdjustmentList', ...arguments);
  }
  /**
   * 生成跨区成本调整数据
   * @param {Object} params
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_generateCrossRegionCostAdjustment() {
    return super.post('pieceworkSalary/generateCrossRegionCostAdjustment', ...arguments);
  }
  /**
   * 计件明细汇总列表
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.crossRegionId 跨区成本调整id(传入时只查该条跨区成本调整对应的汇总数据)
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户名称
   * @param {number} params.userType 用户类型 1协助运营 2协助招聘毛利 3全职协助审核 4全职代审协助审核 5协助招聘收支 7签约提成 8推荐提成
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_getPieceworkSalaryDetailSummaryList() {
    return super.post('pieceworkSalary/getPieceworkSalaryDetailSummaryList', ...arguments);
  }
  /**
   * 计件明细汇总导出
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.crossRegionId 跨区成本调整id(传入时只查该条跨区成本调整对应的汇总数据)
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户名称
   * @param {number} params.userType 用户类型 1协助运营 2协助招聘毛利 3全职协助审核 4全职代审协助审核 5协助招聘收支 7签约提成 8推荐提成
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_exportPieceworkSalaryDetailSummaryList() {
    return super.post('pieceworkSalary/exportPieceworkSalaryDetailSummaryList', ...arguments);
  }
  /**
   * 计件明细汇总 合计(通用)
   * @param {Object} params
   * @param {Array} params.brandIds 品牌ids
   * @param {Array} params.cityIds 城市id
   * @param {Array} params.companyIds 企业ids
   * @param {number} params.crossRegionId 跨区成本调整id(传入时只查该条跨区成本调整对应的汇总数据)
   * @param {number} params.departmentId 部门id
   * @param {number} params.page 页数
   * @param {number} params.recruitmentFeeType 困难任务指定-类型：0：招聘计件人，1：任务指定人
   * @param {number} params.reportStatus 报告状态 0：有效，99：作废
   * @param {number} params.rows 行数
   * @param {string} params.taskName 任务名称
   * @param {string} params.userId 用户id
   * @param {string} params.userName 用户名称
   * @param {number} params.userType 用户类型 1协助运营 2协助招聘毛利 3全职协助审核 4全职代审协助审核 5协助招聘收支 7签约提成 8推荐提成
   * @param {number} params.voucherCostCenterId 承担成本中心id
   * @param {string} params.yearMonth 月份年
   * @returns
   */
  pieceworkSalary_getPieceworkSalaryDetailSummaryCostTotal() {
    return super.post('pieceworkSalary/getPieceworkSalaryDetailSummaryCostTotal', ...arguments);
  }
}
